import { render, staticRenderFns } from "./AgentLoaderComponent.vue?vue&type=template&id=5f2d36d3&"
import script from "./AgentLoaderComponent.vue?vue&type=script&lang=js&"
export * from "./AgentLoaderComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports